"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var tinycolor = require("tinycolor2");

var Breadcrumb = function Breadcrumb(_ref) {
  var path = _ref.path,
      restProps = _objectWithoutProperties(_ref, ["path"]);

  return _react["default"].createElement(BreadcrumbEl, restProps, path.map(function (item, index, arr) {
    return arr.length !== index + 1 ? _react["default"].createElement(Item, {
      key: "".concat(item.name, "_").concat(index),
      variant: restProps.variant
    }, _react["default"].createElement(Link, {
      href: item.to,
      variant: restProps.variant
    }, _react["default"].createElement("div", null, item.name))) : _react["default"].createElement(Item, {
      key: "".concat(item.name, "_").concat(index),
      variant: restProps.variant
    }, _react["default"].createElement(LastItemContent, null, _react["default"].createElement("div", null, item.name)));
  }));
};

Breadcrumb.themeProps = {
  main: {
    name: "BREADCRUMB_CONTAINER",
    description: "The main <ol> element, which also contains custom CSS properties.",
    type: _themeContants.themePropTypes.style
  },
  listItem: {
    name: "BREADCRUMB_ITEM",
    description: "One <li> list item.",
    type: _themeContants.themePropTypes.style
  },
  itemAnchor: {
    name: "BREADCRUMB_LINK",
    description: "Item <a> tag. Will also apply to the last item, which uses a <div>.",
    type: _themeContants.themePropTypes.style
  },
  itemText: {
    name: "BREADCRUMB_TEXT",
    description: "Item inner <div>.",
    type: _themeContants.themePropTypes.style
  }
};

var BreadcrumbEl = _styledComponents["default"].ol.withConfig({
  displayName: "Breadcrumb__BreadcrumbEl",
  componentId: "n9ypa8-0"
})(["--item-h-padding:", ";--item-v-padding:", ";--line-px-height:24px;--item-distance:4px;--bottom-spacing:3px;--separators:14px;--end-padding:6px;--full-width:0;--col-bg:#ddd;--col-txt:", ";--col-hover-bg:", ";--col-hover-txt:", ";--col-current-bg:", ";--col-current-txt:", ";--height:calc(var(--line-px-height) + var(--item-v-padding) * 2);font-family:", ";font-size:", ";user-select:none;list-style:none;display:flex;flex-wrap:wrap;margin-bottom:calc(var(--bottom-spacing) * -1);", ";"], _theming.spacing.small, _theming.spacing.tiny, function (p) {
  return tinycolor.mostReadable("#ddd", ["#333"], {
    includeFallbackColors: true,
    level: "AAA",
    size: "small"
  }).toString();
}, _theming.color.primary, _theming.color.white, _theming.color.primary, function (p) {
  return tinycolor.mostReadable(_theming.color.primary()(p), ["#333", "#fff"], {
    includeFallbackColors: false,
    level: "AA",
    size: "small"
  }).toString();
}, _theming.fontFamily.body, _theming.font.base, (0, _theming.applyVariants)(Breadcrumb.themeProps.main));

var Item = _styledComponents["default"].li.withConfig({
  displayName: "Breadcrumb__Item",
  componentId: "n9ypa8-1"
})(["background-color:var(--col-bg);color:var(--col-txt);margin-left:var(--separators);margin-right:var(--item-distance);margin-bottom:var(--bottom-spacing);flex-grow:var(--full-width);&:hover a{border-color:var(--col-hover-bg);}&:not(:last-child):hover{background-color:var(--col-hover-bg);color:var(--col-hover-txt);}&:first-child{margin-left:0;a{padding-left:var(--end-padding);::before{content:none;}}}&:last-child{cursor:default;margin-right:0;background-color:var(--col-current-bg);color:var(--col-current-txt);> div{border-color:var(--col-current-bg);padding-right:var(--end-padding);}", ";}", ""], (0, _theming.applyVariants)(Breadcrumb.themeProps.listItemLast), (0, _theming.applyVariants)(Breadcrumb.themeProps.listItem));

var linkStyle = (0, _styledComponents.css)(["display:block;text-decoration:none;color:inherit;border-color:var(--col-bg);position:relative;", ":not(:first-child) &::before{content:\"\";display:block;position:absolute;height:100%;border:var(--separators) solid;border-color:inherit;border-left-color:transparent;border-top-width:calc(var(--height) / 2);border-bottom-width:calc(var(--height) / 2);border-right-width:0;box-sizing:border-box;left:calc(var(--separators) * -1);z-index:-1;}div{display:flex;align-items:center;justify-content:center;line-height:var(--line-px-height);padding:var(--item-v-padding) var(--item-h-padding);white-space:nowrap;", ";}", ";"], Item, (0, _theming.applyVariants)(Breadcrumb.themeProps.itemText), (0, _theming.applyVariants)(Breadcrumb.themeProps.itemAnchor));

var Link = _styledComponents["default"].a.withConfig({
  displayName: "Breadcrumb__Link",
  componentId: "n9ypa8-2"
})(["", ";::after{content:\"\";display:block;position:absolute;height:100%;border:var(--separators) solid transparent;border-left-color:inherit;border-top-width:calc(var(--height) / 2);border-bottom-width:calc(var(--height) / 2);border-right-width:0;box-sizing:border-box;top:0;right:calc(var(--separators) * -1);}"], linkStyle);

var LastItemContent = _styledComponents["default"].div.withConfig({
  displayName: "Breadcrumb__LastItemContent",
  componentId: "n9ypa8-3"
})(["", ";"], linkStyle);

Breadcrumb.propTypes = {
  path: _propTypes["default"].array.isRequired
};
var _default = Breadcrumb;
exports["default"] = _default;